import '../../../../../Styles/Tabs.scss'
import React, { useState } from 'react'
import moment from 'moment'
import Swal from 'sweetalert2'
import { useMutation } from '@apollo/client'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import ReportsByUser from '../../../../Global/UserReports/ReportsByUser'
import {
  APPLY_SUSPENSION_USER_APP,
  REMOVE_SUSPENSION_USER_APP,
} from '../../../../../graphql/Catalog/UsersApp/userApp'

const ModalUserAppInfo = ({
  data,
  refetchOrigin = () => {},
  setCloseModal = () => {},
}) => {
  const {
    id,
    name,
    first_name,
    last_name,
    email,
    phone,
    address,
    suspended,
    suspended_by,
    suspended_at,
    suspended_reason,
    UserSuspendedOfUserApp,
  } = data

  const [activeTab, setActiveTab] = useState('info') // Estado para manejar la pestaña activa
  const [reason, setReason] = useState('')
  const [suspensionUser] = useMutation(APPLY_SUSPENSION_USER_APP)
  const [reactiveUser] = useMutation(REMOVE_SUSPENSION_USER_APP)

  const handleSuspensionUser = async () => {
    if (!reason || reason.trim() === '' || reason.trim().length < 1) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Escribe la razón de suspensión',
      })
    }

    const result = await Swal.fire({
      title: ' ',
      text: '¿Estás seguro que deseas suspender al usuario?',
      icon: 'warning',
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: 'Sí, suspender',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
      },
    })
    if (!result.isConfirmed) return

    try {
      await suspensionUser({ variables: { id: parseInt(id), reason } })
      refetchOrigin()
      setReason('')
      setCloseModal(true)
      return toastSweetAlert({
        mode: 'ok',
        message: 'Usuario suspendido correctamente',
      })
    } catch (error) {
      console.error(error)
      toastSweetAlert({
        mode: 'error',
        message: 'Ocurrió un error al suspender el usuario',
      })
    }
  }

  const handleReactiveUser = async () => {
    const result = await Swal.fire({
      title: ' ',
      text: '¿Estás seguro que deseas activar al usuario?',
      icon: 'warning',
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: 'Sí, activar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
      },
    })
    if (!result.isConfirmed) return

    try {
      await reactiveUser({ variables: { id: parseInt(id) } })
      refetchOrigin()
      setReason('')
      setCloseModal(true)
      return toastSweetAlert({
        mode: 'ok',
        message: 'Usuario reactivado correctamente',
      })
    } catch (error) {
      console.error(error)
      toastSweetAlert({
        mode: 'error',
        message: 'Ocurrió un error al reactivar el usuario',
      })
    }
  }

  return (
    <>
      {/* Sistema de pestañas */}
      <div className="tabs-container">
        <button
          className={`tab-button ${activeTab === 'info' ? 'active' : ''}`}
          onClick={() => setActiveTab('info')}
        >
          Información del Usuario
        </button>
        <button
          className={`tab-button ${activeTab === 'reports' ? 'active' : ''}`}
          onClick={() => setActiveTab('reports')}
        >
          Reportes del Usuario
        </button>
      </div>

      {activeTab === 'info' && (
        <>
          {data?.suspended && (
            <div className="row">
              <div className="col-12 mb-3">
                <span className="text-danger text-bold">
                  USUARIO SUSPENDIDO
                </span>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Nombre</span>
              <br />
              <span>{name || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Apellido Paterno</span>
              <br />
              <span>{first_name || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Apellido Materno</span>
              <br />
              <span>{last_name || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Email</span>
              <br />
              <span>{email || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Telefono</span>
              <br />
              <span>{phone || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Direccion</span>
              <br />
              <span>{address || 'N/A'}</span>
            </div>
          </div>
          <hr />

          {suspended === false && (
            <div className="row">
              <div className="col-12 mb-3">
                <span className="text-bold">
                  Si deseas suspender este usuario, debes escribir la razon
                </span>
                <br />
                <textarea
                  className="form-control textarea_not_resize rounded-2"
                  rows="5"
                  placeholder="Ingrese la razón de suspensión"
                  maxLength="500"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          )}

          {suspended === true && (
            <div className="row">
              <div className="col-12 mb-3">
                <span className="text-bold">Motivo de suspension</span>
                <br />
                <span>{suspended_reason || 'N/A'}</span>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
                <span className="text-bold">
                  Usuario que realizo suspension
                </span>
                <br />
                <span>{UserSuspendedOfUserApp?.name || 'N/A'}</span>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
                <span className="text-bold">Fecha de suspension</span>
                <br />
                <span>
                  {suspended_at
                    ? `${moment(suspended_at).format(
                        'dddd D [de] MMMM [de] YYYY'
                      )}`
                    : 'N/A'}
                </span>
              </div>
            </div>
          )}

          <div
            className="mt-4 d-flex justify-content-end"
            style={{ gap: '10px' }}
          >
            <button
              className="btn btn-migrates-white"
              onClick={() => setCloseModal(true)}
            >
              Cerrar
            </button>

            {!suspended && (
              <button className="btn btn-migrates" onClick={handleSuspensionUser}>
                Suspender usuario
              </button>
            )}

            {suspended && (
              <button className="btn btn-migrates" onClick={handleReactiveUser}>
                Reactivar usuario
              </button>
            )}
          </div>
        </>
      )}

      {activeTab === 'reports' && (
        <div className="row">
          <div className="col-12 mb-3">
            <ReportsByUser userId={id} />
          </div>
        </div>
      )}
    </>
  )
}

export default ModalUserAppInfo
